var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1337 22.1333L23.5337 12.7333L21.667 10.8667L14.1337 18.4L10.3337 14.6L8.46699 16.4667L14.1337 22.1333ZM16.0003 29.3333C14.1559 29.3333 12.4225 28.9833 10.8003 28.2833C9.1781 27.5833 7.76699 26.6333 6.56699 25.4333C5.36699 24.2333 4.41699 22.8222 3.71699 21.2C3.01699 19.5778 2.66699 17.8444 2.66699 16C2.66699 14.1555 3.01699 12.4222 3.71699 10.8C4.41699 9.17777 5.36699 7.76666 6.56699 6.56666C7.76699 5.36666 9.1781 4.41666 10.8003 3.71666C12.4225 3.01666 14.1559 2.66666 16.0003 2.66666C17.8448 2.66666 19.5781 3.01666 21.2003 3.71666C22.8225 4.41666 24.2337 5.36666 25.4337 6.56666C26.6337 7.76666 27.5837 9.17777 28.2837 10.8C28.9837 12.4222 29.3337 14.1555 29.3337 16C29.3337 17.8444 28.9837 19.5778 28.2837 21.2C27.5837 22.8222 26.6337 24.2333 25.4337 25.4333C24.2337 26.6333 22.8225 27.5833 21.2003 28.2833C19.5781 28.9833 17.8448 29.3333 16.0003 29.3333Z",
    fill: "#0F9918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenBg);
export default __webpack_public_path__ + "static/media/check-green-bg.e07a825c2bf6230ff2602cea63a2a608.svg";
export { ForwardRef as ReactComponent };